import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mt-20" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "custom-checkbox" }
const _hoisted_7 = { class: "col-md-4 mt-20" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "custom-checkbox" }
const _hoisted_10 = { class: "col-md-4 mt-20" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-4 mb-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-4 mb-3" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-4 mb-3" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-4 mb-3" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { class: "col-md-4 mb-3" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = { class: "col-md-4 mb-3" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = { class: "col-md-4 mb-3" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "col-md-4 mb-3" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = { class: "col-md-4 mb-3" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = { class: "col-md-4 mb-3" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = { class: "col-md-4 mb-3" }
const _hoisted_36 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_37 = { class: "col-md-4 mb-3" }
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = { class: "col-md-8 mb-3" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = { class: "col-md-12 mb-md-25" }
const _hoisted_42 = {
  class: "accordion",
  id: "basicAccordion"
}
const _hoisted_43 = { class: "accordion-item mb-0 bord1" }
const _hoisted_44 = {
  id: "basicCollapseOne",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#basicAccordion"
}
const _hoisted_45 = { class: "accordion-body" }
const _hoisted_46 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_47 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "border border-primary mb-10" }
const _hoisted_50 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_51 = { class: "col-md-5" }
const _hoisted_52 = { class: "d-flex float-end" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "col-md-5 mb-2" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_57 = { class: "col-md-5 mb-2" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_61 = { class: "col-md-2 mb-2" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "col-md-12 mt-3" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "societeForm",
        onSubmit: _ctx.addSociete,
        "validation-schema": _ctx.societeSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "estRegimeTPS",
                    type: "checkbox",
                    value: true,
                    "unchecked-value": false
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("input", _mergeProps({ type: "checkbox" }, field), null, 16)
                    ]),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode(" Est Régime TPS ? "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _createVNode(_component_Field, {
                    name: "estModeMecef",
                    type: "checkbox",
                    value: true,
                    "unchecked-value": false
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("input", _mergeProps({ type: "checkbox" }, field), null, 16)
                    ]),
                    _: 1
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[5] || (_cache[5] = _createTextVNode(" Est Mode MECEF ? "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Sigle "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "sigle",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le sigle"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "sigle",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Dénomination"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "denomination",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la dénomination"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "denomination",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Raison sociale "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "raisonSocial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la raison sociale"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "raisonSocial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" N° RCCM "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "rccm",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le régistre de commerce"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "rccm",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" N° IFU "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "ifu",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'ifu"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "ifu",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Téléphone "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "telephone",
                  modelValue: _ctx.telephone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telephone) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _ctx.validate,
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (!_ctx.validPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Veuillez entrer un numéro correcte"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Adresse "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "adresse",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'adresse"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "adresse",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message Commercial ", -1)),
                _createVNode(_component_Field, {
                  name: "messageCommercial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer votre message commercial"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "messageCommercial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Lieu d'impression des factures ", -1)),
                _createVNode(_component_Field, {
                  name: "lieuImpression",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le lieu d'impression"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "lieuImpression",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Joindre le logo ", -1)),
                _createVNode(_component_Field, {
                  name: "logo",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Logo"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "logo",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Joindre l'entête"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "entete",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entête"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "entete",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Joindre le pied de page ", -1)),
                _createVNode(_component_Field, {
                  name: "pied",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Pied de page"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "pied",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Lien API ", -1)),
                _createVNode(_component_Field, {
                  name: "lienApi",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Lien API"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "lienApi",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " API Nim ", -1)),
                _createVNode(_component_Field, {
                  name: "apNim",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "API Nim"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "apNim",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " API Token ", -1)),
                _createVNode(_component_Field, {
                  name: "apiToken",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "API Token"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "apiToken",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[26] || (_cache[26] = _createElementVNode("h2", {
                    class: "accordion-header",
                    id: "headingOne"
                  }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#basicCollapseOne",
                      "aria-expanded": "false",
                      "aria-controls": "basicCollapseOne"
                    }, " Comptes bancaires ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-7" }, [
                                  _createElementVNode("h3", { class: "fs-4 text-white" }, " Comptes bancaires ")
                                ], -1)),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                                      type: "button",
                                      disabled: _ctx.isDisable,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowCompte()))
                                    }, _cache[21] || (_cache[21] = [
                                      _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                                      _createTextVNode(" Ajouter un compte ")
                                    ]), 10, _hoisted_53),
                                    _createVNode(_component_router_link, { to: "/liste-mouvements" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                                  _createElementVNode("div", { class: "col-md-5" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                      _createTextVNode(" Banque "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-5" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                      _createTextVNode(" Numéro de compte "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-2" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                                  ])
                                ], -1)),
                                _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comptes, (compte, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _createVNode(_component_Multiselect, {
                                          options: _ctx.banqueOptions,
                                          searchable: true,
                                          "track-by": "label",
                                          label: "label",
                                          modelValue: compte.banque,
                                          "onUpdate:modelValue": ($event: any) => ((compte.banque) = $event),
                                          placeholder: "Sélectionner la banque"
                                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                        (_ctx.valideteRowCompte(compte.banque))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, " La banque est obligatoire. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": ($event: any) => ((compte.numCompte) = $event),
                                          class: _normalizeClass(_ctx.valideteRowCompte(compte.numCompte)
                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                        : 'form-control shadow-none fs-md-15 text-black '
                                      ),
                                          placeholder: "Entrer le compte"
                                        }, null, 10, _hoisted_59), [
                                          [_vModelText, compte.numCompte]
                                        ]),
                                        (_ctx.valideteRowCompte(compte.numCompte))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, " Le numéro est obligatoire. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("button", {
                                        class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removeRowCompte(index))
                                      }, _cache[23] || (_cache[23] = [
                                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                      ]), 8, _hoisted_62)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: !_ctx.validPhone
                }, " Ajouter une sociéte ", 8, _hoisted_65),
                _createVNode(_component_router_link, {
                  to: "/societes/liste-societes",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}